<button [tabindex]="index"
        [disabled]="disabled"
        [type]="formType"
        class="btn"
        [ngClass]="[styleType || 'noStyleType', buttonClass || 'noButtonClass']"
        [class.inactive]="disabled"
        [title]="title || ''">
    <ng-content></ng-content>
</button>
